import * as actionTypes from '../actions/actionTypes';

const initialState = {
  data: [],
  notes: [],
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_DRAFT:
      return {
        ...state,
        data: action.payload.data,
      };
    case actionTypes.REMOVE_DRAFT:
      return {
        ...state,
        data: action.payload.data,
      };
    case actionTypes.NOTES_STORE:
      return {
        ...state,
        notes: [...action.payload],
        loading: false,
      };
    case actionTypes.NOTES_RESET:
      return {
        ...state,
        notes: [],
        loading: true,
      };
    // case actionTypes.RESET_DRAFT:
    //   return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
